import { pick } from 'ramda';
import { useCallback } from 'react';
import { getCleanUrl } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useClearIdsInPath = () => {
    const {
        dynamicRoutingUrls,
        leaderboardCustomPages /* TotalCasino changes */
    } = useAppSelector(pick(['dynamicRoutingUrls', 'leaderboardCustomPages']));

    return useCallback((pathname) => {
        const cleanUrl = getCleanUrl(pathname);

        /* TotalCasino changes */
        const lbPages = leaderboardCustomPages?.map(lb => lb?.leaderboardPage).filter(Boolean); /* TotalCasino changes */

        const allRoutes = [...dynamicRoutingUrls, ...lbPages];

        return allRoutes.find(page => cleanUrl.startsWith(`${page}/`) || cleanUrl === page)
            || pathname;
        /* TotalCasino changes */
    }, [dynamicRoutingUrls, leaderboardCustomPages]);
};
